import styled from "@emotion/styled";
import { DebugPanelTokenListToggle } from "./DebugPanelTokenListToggle";
import { useMemo, useState } from "react";
import { AnimateChangeInHeight } from "components/general/AnimateChangeInHeight";
import { DebugPanelGlobalStoreToggle } from "./DebugPanelGlobalStoreToggle";
import { DebugPanelApprovalStoreToggle } from "./DebugPanelApprovalStoreToggle";
import { CloseIcon } from "../../../../components/Icons";
import { css } from "@emotion/react";
import { Z_INDICES } from "config/consts";
import EnvironmentToggle from "./EnvironmentToggle";

export const DebugPanel = () => {
  const [isOpen, setIsOpen] = useState(false);
  const content = useMemo(() => {
    if (!isOpen) return null;
    return (
      <div>
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            align-items: center;
          `}
        >
          <Title>Debugger</Title>
          <CloseIcon width={20} height={20} onClick={() => setIsOpen(false)} />
        </div>
        <EnvironmentToggle />
        <DebugPanelTokenListToggle />
        <DebugPanelGlobalStoreToggle />
        <DebugPanelApprovalStoreToggle />
      </div>
    );
  }, [isOpen]);
  return (
    <Container isOpen={isOpen} heightAddOn={18} onClick={() => !isOpen && setIsOpen(true)}>
      {content}
    </Container>
  );
};

// Sub-components

const Container = styled(AnimateChangeInHeight)<{ isOpen: boolean }>`
  position: fixed;
  z-index: ${Z_INDICES.POP_UPS + 100};
  top: 10px;
  right: 10px;
  background-color: red;
  border-radius: 10px;
  color: white;
  padding: 0.5rem;
  cursor: pointer;
  border: 1px solid red;
  display: flex;
  flex-direction: column;
  transition: opacity 0.2s linear;
  &:hover {
    opacity: 0.9;
  }
`;

const Title = styled.h6`
  font-size: 14px;
  margin: 4px 0 10px 0;
`;
